import React from 'react'
import { withTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'

import mobileCollage from '../../images/png/home/hello/mobilecollage.png'

import imgPersonality from '../../images/png/types/img__personality.png'
import imgQuotes from '../../images/png/types/img__quotes.png'
import imgPhotostory from '../../images/png/types/img__photostory.png'
import imgBeforeAfter from '../../images/png/types/img__before-after.png'
import imgRankBattle from '../../images/png/types/img__rank-battle.png'
import imgMemory from '../../images/png/types/img__memory.png'

import iconTrivia from '../../images/png/types/icon__trivia.svg'
import iconPhotostory from '../../images/png/types/icon__photostory.svg'
import iconMemory from '../../images/png/types/icon__memory.svg'
import iconQuotes from '../../images/png/types/icon__quotes.svg'
import iconPersonality from '../../images/png/types/icon__personality.svg'
import iconRankBattle from '../../images/png/types/icon__rank-battle.svg'
import iconBeforeAfter from '../../images/png/types/icon__before-after.svg'

const HelloBlock = ({ t }) => {
    return (
        <div className="home__hello-block">
            <h1>{t('_pages._home._hello_block.title')}</h1>
            <div className="link">
                <Link
                    to="/auth?action=registration"
                    className="try-btn button-style"
                    data-size="lg"
                    data-variant="primary-danger--2"
                >
                    {t('_pages._home._hello_block.try_for_free')}
                </Link>
            </div>
            <h2>{t('_pages._home._hello_block.subtitle')}</h2>

            <ul className="types">
                <li className="type type--photostory">
                    <Link className="link" to="/products/photostory"></Link>
                    <img src={imgPhotostory} alt="img__photostory" />
                    <div className="tag">
                        <Link className="link" to="/products/photostory"></Link>
                        <img src={iconPhotostory} alt="icon__photostory" />
                        <span style={{ color: '#24BFD8' }}>{t('_pages._home._hello_block._types.photostory')}</span>
                    </div>
                </li>
                <li className="type type--memory">
                    <Link className="link" to="/products/memory-game"></Link>
                    <img src={imgMemory} alt="img__memory" />
                    <div className="tag">
                        <Link className="link" to="/products/memory-game"></Link>
                        <img src={iconMemory} alt="icon__memory" />
                        <span style={{ color: '#34C96D' }}>{t('_pages._home._hello_block._types.memory')}</span>
                    </div>
                </li>
                <li className="type type--quotes">
                    <Link className="link" to="/products/quotes"></Link>
                    <img src={imgQuotes} alt="img__quotes" />
                    <div className="tag">
                        <Link className="link" to="/products/quotes"></Link>
                        <img src={iconQuotes} alt="icon__quotes" />
                        <span style={{ color: '#4B4E58' }}>{t('_pages._home._hello_block._types.quotes')}</span>
                    </div>
                </li>
                <li className="type type--personality">
                    <Link className="link" to="/products/personality-quiz"></Link>
                    <img src={imgPersonality} alt="img__personality" />
                    <div className="tag">
                        <Link className="link" to="/products/personality-quiz"></Link>
                        <img src={iconPersonality} alt="icon__personality" />
                        <span style={{ color: '#9560E6' }}>{t('_pages._home._hello_block._types.personality')}</span>
                    </div>
                </li>
                <li className="type type--rank-battle">
                    <Link className="link" to="/products/rank-battle"></Link>
                    <img src={imgRankBattle} alt="img__rank-battle" />
                    <div className="tag">
                        <Link className="link" to="/products/rank-battle"></Link>
                        <img src={iconRankBattle} alt="icon__rank-battle" />
                        <span style={{ color: '#2970FB' }}>{t('_pages._home._hello_block._types.rank')}</span>
                    </div>
                </li>
                <li className="type type--before-after">
                    <Link className="link" to="/products/before-after"></Link>
                    <img src={imgBeforeAfter} alt="img__before-after" />
                    <div className="tag">
                        <Link className="link" to="/products/before-after"></Link>
                        <img src={iconBeforeAfter} alt="icon__before-after" />
                        <span style={{ color: '#C86445' }}>{t('_pages._home._hello_block._types.before_after')}</span>
                    </div>
                </li>

                {/* Free */}
                <li className="type type--trivia">
                    <div className="tag">
                        <Link className="link" to="/products/trivia-quiz"></Link>
                        <img src={iconTrivia} alt="icon__trivia" />
                        <span style={{ color: '#FF5656' }}>{t('_pages._home._hello_block._types.trivia')}</span>
                    </div>
                </li>
            </ul>

            <div className="mobile-collage">
                <img src={mobileCollage} alt="mobile-collage" />
            </div>
        </div>
    )
}

export default withTranslation('translations')(HelloBlock)
